import { render } from "./TheDmsHeader.vue?vue&type=template&id=181cdde6&scoped=true&ts=true"
import script from "./TheDmsHeader.vue?vue&type=script&lang=ts"
export * from "./TheDmsHeader.vue?vue&type=script&lang=ts"

import "./TheDmsHeader.vue?vue&type=style&index=0&id=181cdde6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181cdde6"]])

export default __exports__